import { ClassNameProps, makeClassName, Row, StyleProps } from "@hex-insights/core";
import { Table } from "@hex-insights/tables";
import { ContractInstallment } from "../../../../Utilities";
import { ContractInstallmentFormat, ModelFormat } from "../../../Format";
import { ContractInstallmentUtilities } from "../../../Utilities";
import { PaymentStatusBadge } from "../../_General/PaymentStatus";
import { ContractInstallmentActionButtons } from "../ActionButtons";
import styles from "./styles.module.css";

const columns = ["status", "dueDate", "description", "amount", "actions"];

const columnWidths = {
	actions: "5rem",
};

export type ContractInstallmentsListProps = {
	variant: "admin" | "parent";
	contractInstallments: (Pick<ContractInstallment, "id" | "dueDate"> &
		ContractInstallmentUtilities.PrecomputedContractInstallment)[];
} & Partial<ClassNameProps & StyleProps>;

export function ContractInstallmentsList({
	variant,
	contractInstallments,
	className,
	style,
}: ContractInstallmentsListProps) {
	return (
		<Table
			columns={columns}
			columnWidths={columnWidths}
			className={makeClassName(styles["table"], className)}
			style={style}
		>
			<Table.Header className={styles["table__header"]}>
				<Table.Row>
					<Table.Heading column="status" noResize>
						Status
					</Table.Heading>
					<Table.Heading column="dueDate" noResize>
						Due
					</Table.Heading>
					<Table.Heading column="description" noResize>
						Description
					</Table.Heading>
					<Table.Heading column="amount" noResize>
						Amount
					</Table.Heading>
					<Table.Heading column="actions" noResize>
						Actions
					</Table.Heading>
				</Table.Row>
			</Table.Header>
			<Table.Body>
				{contractInstallments.map((contractInstallment) => (
					<Table.Row key={contractInstallment.id} className={styles["row"]}>
						<Table.Cell column="status" className={styles["cell--centered-content"]}>
							<Row align="center" className={styles["cell--centered-content__content"]}>
								<PaymentStatusBadge status={contractInstallment.paymentStatus} />
							</Row>
						</Table.Cell>
						<Table.Cell column="dueDate" oneLine>
							{ContractInstallmentFormat.Fields.dueDate(contractInstallment.dueDate)}
						</Table.Cell>
						<Table.Cell column="description" oneLine>
							Installment {contractInstallment.index + 1} of {contractInstallment.totalInstallments}
						</Table.Cell>
						<Table.Cell column="amount" oneLine numeric className={styles["cell--amount"]}>
							{ModelFormat.money(contractInstallment.totalAmount)}
						</Table.Cell>
						<Table.Cell column="actions" className={styles["cell--centered-content"]}>
							<Row align="center" className={styles["cell--centered-content__content"]}>
								<ContractInstallmentActionButtons variant={variant} contractInstallmentID={contractInstallment.id} />
							</Row>
						</Table.Cell>
					</Table.Row>
				))}
			</Table.Body>
		</Table>
	);
}
